import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { useRouter } from 'expo-router'
import { formatWinPct, type WinRateEntry } from '../../lib/hallOfFame'

/** One ranked player. Used by the Hall of Fame preview and the full win-rate page. */
export function WinRateRow({ entry }: { entry: WinRateEntry }) {
  const router = useRouter()
  return (
    <TouchableOpacity
      onPress={() => router.push(`/(app)/u/${entry.username}`)}
      accessibilityLabel={`Rank ${entry.rank}, ${entry.displayName}, ${formatWinPct(entry.stats.winPct)} win rate. View profile`}
      accessibilityRole="button"
      testID={`hof-win-rate-row-${entry.rank}`}
      className="flex-row items-center bg-paper-up border border-olive rounded-lg p-3 gap-3"
    >
      <Text className="font-stencil text-blood text-lg w-8 text-center">{entry.rank}</Text>
      <View className="flex-1">
        <Text className="font-stencil text-ink text-base" numberOfLines={1}>{entry.displayName}</Text>
        <Text className="font-typed text-ink-soft text-xs" numberOfLines={1}>@{entry.username}</Text>
      </View>
      <View className="items-end">
        <Text className="font-stencil text-ink text-base">{formatWinPct(entry.stats.winPct)}</Text>
        <Text className="font-typed text-ink-soft text-[10px]">
          {entry.stats.wins}–{entry.stats.losses} · {entry.stats.gamesPlayed}g
        </Text>
      </View>
    </TouchableOpacity>
  )
}
